import { defaultTheme, Progress } from '@agro-club/agroclub-shared'
import { useTableData } from 'modules/domain/common/hooks'
import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { PositionColumn } from './PositionColumn'
import { UsContractPositionDetailed } from 'modules/domain/usContracts/types'
import { DEFAULT_MARGIN } from '../List/OpenBoard'

export const Wrapper = styled.div`
  border-radius: 0 8px 0 0;
  min-height: max-content;
  max-height: 100%;
  display: flex;
  gap: 0 16px;
`
const TwoColumns = styled.div`
  display: flex;
`
const PositionsColumns = styled.div`
  background: ${defaultTheme.color.backgroundSecondary};
  border-radius: 8px;
`

export type BestCard = {
  id: string
}

type Props = {
  listRequestParams: ListRequestParams
  totals: Record<string, number | undefined>
  totalProgress: Progress
}

export const PositionsBlock: FC<Props> = ({ listRequestParams, totals, totalProgress }) => {
  const { t } = useTranslation('usContracts')

  const [selectedLongPosition, setSelectedLongPosition] = useState<UsContractPositionDetailed | null>(null)
  const [selectedShortPosition, setShortSelectedPosition] = useState<UsContractPositionDetailed | null>(null)

  const { progress: progressLong, data: longPositions = [] } = useTableData<UsContractPositionDetailed>(
    endpoints.contractLongPositions(),
    listRequestParams,
    true,
  )

  const { progress: progressShort, data: shortPositions = [] } = useTableData<UsContractPositionDetailed>(
    endpoints.contractShortPositions(),
    listRequestParams,
    true,
  )

  return (
    <Wrapper>
      <PositionsColumns>
        <TwoColumns>
          <PositionColumn
            topMargin={DEFAULT_MARGIN}
            selectedPosition={selectedLongPosition}
            remainingQuantity={totals.long}
            totalProgress={totalProgress}
            onSelectPosition={setSelectedLongPosition}
            borderRadius="8px 0 0 8px"
            title={t('longPosition')}
            progress={progressLong}
            positions={longPositions}
          />
          <PositionColumn
            topMargin={DEFAULT_MARGIN}
            selectedPosition={selectedShortPosition}
            remainingQuantity={totals.short}
            totalProgress={totalProgress}
            onSelectPosition={setShortSelectedPosition}
            borderRadius="0 8px 0 8px"
            title={t('shortPosition')}
            progress={progressShort}
            positions={shortPositions}
          />
        </TwoColumns>
      </PositionsColumns>
    </Wrapper>
  )
}
